import React from "react";

export const EmailInput = () => {
  return (
    <input name="email" placeholder="Email" className="input_email"/>
  )
}
